import IconAddCircle from '@creditflowresearch/uilib/Icon/IconAddCircle';
import Button from '@creditflowresearch/uilib/Button';
import { useAskAiChatContext } from '@/creditflowresearch/application/AskAiChat/context/AskAiChatContext';

const ChatHeaderActions = () => {
  const { startNewChat, messages, canSwitchChat } = useAskAiChatContext();

  return (
    <Button
      variant="text"
      size="S"
      icon={ <IconAddCircle /> }
      iconSize={ 16 }
      onClick={ startNewChat }
      disabled={ !messages.length || !canSwitchChat }
      ariaLabel="New chat"
      dataTest="askAiChatNewChatButton"
    />
  );
};

export default ChatHeaderActions;
